import { render, staticRenderFns } from "./uploadresour.vue?vue&type=template&id=4debfe2e&scoped=true"
import script from "./uploadresour.vue?vue&type=script&lang=js"
export * from "./uploadresour.vue?vue&type=script&lang=js"
import style0 from "./uploadresour.vue?vue&type=style&index=0&id=4debfe2e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4debfe2e",
  null
  
)

export default component.exports